/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dictation_PreparingInputs */

const en_dictation_preparing = /** @type {(inputs: Dictation_PreparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparing speech recognition…`)
};

const pt_br2_dictation_preparing = /** @type {(inputs: Dictation_PreparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparando reconhecimento de voz…`)
};

/**
* | output |
* | --- |
* | "Preparing speech recognition…" |
*
* @param {Dictation_PreparingInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dictation_preparing = /** @type {((inputs?: Dictation_PreparingInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dictation_PreparingInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dictation_preparing(inputs)
	return pt_br2_dictation_preparing(inputs)
});